/* template */
<template minapp="mpx" xlang="wxml"><div :style="[(wrapStyle)] | transRpxStyle" class="guide-tips-wrap"><mpx-image :src="(icon)" class="icon"/><div :style="[(titleStyle)] | transRpxStyle" class="title"><mpx-rich-text :nodes="(title)"></mpx-rich-text></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m99b597a0"}'>
  @import '~@/mixins/stylus/color.styl'

  .guide-tips-wrap
    background: linear-gradient(0deg, rgba(255, 89, 0, 0.05), rgba(255, 89, 0, 0.05)), #FFFFFF;
    box-sizing: border-box;
    border: 1.5px solid #FFFFFF;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 4px 0 4px 0;
    .icon
      width: 36px;
      height: 36px; 
      margin-right: 12rpx;
      margin-left: 21px;
    .title
      font-family: PingFangSC-Medium;
      font-size: 14px;
      font-weight: normal;
      line-height: 16px;
      letter-spacing: 0px;


</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m99b597a0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./guide-tips.mpx.js?isComponent&outputPath=components%2Fguide-tips99b597a0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./guide-tips.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fguide-tips99b597a0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m99b597a0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/guide-tips99b597a0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-rich-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
